module.exports = __webpack_public_path__ + "img/login-image.2cb0c13c.png";